"use client";
import styles from "./InputDesign.module.css";

export const ChangePasswordSection = ({ 
  isEditable, 
  showChangePassword, 
  setShowChangePassword, 
  formData, 
  handleInputChange, 
  handleResetPassword 
}) => {
  return (
    <section className={styles.passwordCard}>
      <header className={styles.passwordHeader}>
        <h2 className={styles.passwordTitle}>Change password</h2>
        <p className={styles.passwordDescription}>
          Update your password to keep your account secure. Make sure to use a strong password.
        </p>
      </header>
      
      <div 
        className={styles.sectionHeader}
        onClick={() => setShowChangePassword(!showChangePassword)}
      >
        <h3>Change Password</h3>
        <i className={`fas fa-chevron-${showChangePassword ? 'up' : 'down'}`}></i>
      </div>
      
      {showChangePassword && (
        <form 
          className={styles.passwordForm}
          onSubmit={(e) => { e.preventDefault(); handleResetPassword(); }}
        >
          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel}>Old Password</label>
            <input
              type="password"
              value={formData?.oldPassword || ''}
              onChange={(e) => handleInputChange(e, 'oldPassword')}
              className={styles.fieldInput}
              disabled={!isEditable}
              placeholder="Enter your current password"
            />
          </div>
          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel}>New Password</label>
            <input
              type="password"
              value={formData?.newPassword || ''}
              onChange={(e) => handleInputChange(e, 'newPassword')}
              className={styles.fieldInput}
              disabled={!isEditable}
              placeholder="Enter your new password"
            />
          </div>
          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel}>Confirm New Password</label>
            <input
              type="password"
              value={formData?.confirmPassword || ''}
              onChange={(e) => handleInputChange(e, 'confirmPassword')}
              className={styles.fieldInput}
              disabled={!isEditable}
              placeholder="Confirm your new password"
            />
          </div>
          {isEditable && (
            <button type="submit" className={styles.sendButton}>
              Reset Password
            </button>
          )}
        </form>
      )}
    </section>
  );
};
